import { c as _c } from "react/compiler-runtime";
import { getT } from "@local/i18n/src/t";
import { getLanguageForMarket } from "@local/i18n/src/languages";
import { pdp } from "@local/i18n/src/catalogs/pdp";
export const DiscountTag = t0 => {
  const $ = _c(14);
  const {
    discount,
    market
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== discount || $[1] !== market) {
    const t = getT(getLanguageForMarket(market), {
      pdp
    });
    t3 = "relative ml-1 inline-flex items-center py-1 pr-3 pl-4 text-sm font-semibold text-green-700";
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <svg aria-hidden="true" className="absolute inset-0 h-full w-full" viewBox="0 0.0442 95 23" fill="none" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M10.0693 0.0440484C10.0693 0.0832913 10.0219 0.102944 9.99414 0.0751954L9.96299 0.0440484C9.93867 0.0197211 9.89922 0.0197212 9.8749 0.0440485L1.17193 8.74701C-0.390165 10.3091 -0.390166 12.8418 1.17193 14.4039L9.81226 23.0442C9.87118 23.1031 9.96671 23.1031 10.0256 23.0442C10.0539 23.0159 10.0923 23 10.1323 23H90.0693C92.2785 23 94.0693 21.2091 94.0693 19V4C94.0693 1.79086 92.2785 0 90.0693 0H10.1134C10.0891 0 10.0693 0.0197211 10.0693 0.0440484Z" fill="currentColor" /></svg>;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    t1 = "relative text-white";
    t2 = t("pdp.savePercent", {
      pct: discount
    });
    $[0] = discount;
    $[1] = market;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[7] !== t1 || $[8] !== t2) {
    t5 = <span className={t1}>{t2}</span>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t4 || $[12] !== t5) {
    t6 = <span className={t3}>{t4}{t5}</span>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};
export default DiscountTag;